import styled, { css } from 'styled-components';
import { IMenuRenderInfo } from '../../../../components/ui/calendar/calendars';
import { WCS } from '../../../../components/ui/calendar/calendar-week/week-utils';
import { ReservationModes } from '../../../../types/reservation-form';

export const ReservationFormStyledSC = styled.div<{
  mode: ReservationModes;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;

  &.event-edit-form-modal {
    padding: 40px;
  }

  position: relative;
  background: white;
  box-shadow: ${({ mode }) => (mode === 'edit' ? 'none' : '0 2px 15px rgba(51, 61, 108, 0.1)')};
  border-radius: ${({ mode }) => (mode === 'edit' ? 0 : '24px')};

  .input-root {
    display: flex;
  }

  .loading-indicator {
    text-align: center;
  }

  .submit-button {
    width: ${({ mode }) => (mode === 'edit' ? '30%' : '100%')};
  }

  .time-range-fields {
    display: flex;
    gap: 16px;
  }

  form {
    .rc-picker {
      .rc-picker-dropdown {
        .rc-picker-content {
          padding: 8px 14px !important;
        }
      }
    }

    .ui-react-select__menu-list {
      max-height: 180px;
    }

    .title-input {
      &::placeholder {
        color: rgba(51, 61, 108, 0.5);
      }
    }
  }
`;

export const HeaderStyledSC = styled.div<{
  mode: ReservationModes;
  direction?: IMenuRenderInfo<any>['direction'];
}>`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;

  .title-field {
    margin-right: 5%;
    width: ${({ mode }) => (mode === 'edit' ? '65%' : '100%')};
    display: ${({ mode }) => (mode === 'edit' ? 'inline-block' : 'block')};
  }

  .title-input {
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 24px;
    line-height: 24px;
  }

  .actions {
    position: absolute;
    top: -25px;
    right: ${({ mode }) => (mode === 'edit' ? 0 : '-20px')};
    padding-left: 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    .action {
      border: none;
      outline: none;
      background: none;
      cursor: pointer;
      padding: 0;
      margin-left: 15px;

      &:hover {
        opacity: 0.5;
      }

      button {
        padding: 0;
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }
  }

  .patient-select-label {
    margin-bottom: 15px;
  }

  ${({ mode, direction }) => {
    if (mode === 'edit') {
      return css``;
    } else {
      return css`
        &::before {
          content: '';
          width: 12px;
          height: 12px;
          position: absolute;
          transform: rotate(-45deg);
          background: white;
          z-index: 1;
          ${() => {
            if (direction?.horizontalPosition === 'right') {
              return css`
                left: -45px;
                top: -15px;
              `;
            } else {
              return css`
                left: ${WCS.menuWidth - 45}px;
                top: -15px;
              `;
            }
          }};
        }
      `;
    }
  }};
`;
